export const formatNumber = (number) => {
    return parseInt(number).toLocaleString("en-NG")
}